<template>
  <div class="view">
    <div class="group" v-for="group in groups" :key="group.id">
      <b-form-checkbox
        :value="group.rcd == null"
        @change="group.rcd = group.rcd == null ? 0 : null"
        style="margin-bottom: 15px;"
      >Fehlerschutzschalter hinzufügen</b-form-checkbox>

      <b-form-select v-if="group.rcd != null" v-model="group.rcd" :options="rcdsSelect"/>

      <div
        v-for="(fuse, i) in group.fuses" :key="i"
        class="fuse"
        @drop="onDrop($event, fuse)"
        @dragover="onDragOver"
        @dragenter="onDragEnter($event, fuse)"
        @dragleave="onDragLeave">
        Breaker ({{fuse.breaker.amps}}A, {{fuse.breaker.te}}TE, {{fuse.breaker.phases}} polig)
        <div>
          <img
            v-for="(module, i) in fuse.modules"
            style="width: 80px;"
            :key="i"
            :src="module.module.imageUrl"
          />
        </div>
      </div>
      <div class="fuse new"
        @drop="onDrop($event, null, group)"
        @dragover="onDragOver"
        @dragleave="onDragLeave"
        @dragenter="onDragEnter">+</div>
      <br />
      <b-button
        style="margin-top: 15px;"
        variant="danger"
        @click="deleteGroup(group)"
      >Verteilungskreis löschen</b-button>
    </div>
    <b-button @click="addGroup">Neuer Verteilungskreis</b-button>
  </div>
</template>

<script>
export default {
  props: {
    currentDragItem: Object
  },
  data: () => ({
    groups: [],
    dropAllowed: false,
    breakers: [
      { id: "412412", te: 1, amps: 20, phases: 1 },
      { id: "412413", te: 1, amps: 16, phases: 1 },
      { id: "412414", te: 3, amps: 16, phases: 3 },
      { id: "412415", te: 1, amps: 32, phases: 1 },
      { id: "412416", te: 3, amps: 32, phases: 3 },
      { id: "412417", te: 1, amps: 63, phases: 1 },
      { id: "412418", te: 3, amps: 63, phases: 3 }
    ],
    rcds: [
      { id: "412420", te: 4, amps: 25, phases: 3 },
      { id: "412422", te: 4, amps: 40, phases: 3 },
      { id: "412424", te: 4, amps: 63, phases: 3 }
    ]
  }),
  computed: {
    rcdsSelect() {
      return this.rcds.map((rcd, i) => {
        return {
          value: i,
          text: `${rcd.id}, ${rcd.te}TE, ${rcd.amps}A, ${rcd.phases} phases`
        }
      })
    }
  },
  methods: {
    imageUrlForModule(id) {
      return `${
        process.env.VUE_APP_API
      }/modules/${id}/image`;
    },
    onDragEnter(event, fuse) {
      if (event.target == event.relatedTarget) return
      event.target.classList.add("drag-over")
      event.dataTransfer.dropEffect = "copy"
      this.dropAllowed = false
      const meta = this.currentDragItem.module.metadata
      if (this.currentDragItem && meta.amperage) {
        this.dropAllowed = true
      }

      if (fuse) {
        this.dropAllowed = false
        if (fuse.modules.find(m => m.module.metadata.voltage != meta.voltage)) return
        if (meta.amperage != fuse.breaker.amps) return
        this.dropAllowed = true
      }
    },
    onDragOver(event) {
      event.dataTransfer.dropEffect = this.dropAllowed ? "copy" : "none"
      event.preventDefault()
    },
    onDragLeave(event) {
      event.target.classList.remove("drag-over")
    },
    onDrop(event, fuse, group) {
      event.preventDefault()
      event.target.classList.remove("drag-over")

      if (!fuse) {
        this.addFuse(group)
      } else {
        fuse.modules.push(this.currentDragItem)
      }
    },
    addGroup() {
      this.groups.push({
        id: (Math.random() * 1000000) | 0,
        rcd: null,
        fuses: []
      });
    },
    addFuse(group) {
      const meta = this.currentDragItem.module.metadata
      const fuse = {
        breaker: this.breakers.find(b => b.amps == meta.amperage),
        modules: [this.currentDragItem]
      };
      group.fuses.push(fuse);
    },
    deleteFuse(group, fuse) {
      group.fuses.splice(group.fuses.indexOf(fuse), 1);
    },
    deleteGroup(group) {
      this.groups.splice(this.groups.indexOf(group), 1);
    }
  }
};
</script>

<style scoped>
.view {
  text-align: left;
  padding: 15px;
  height: 100%;
  overflow-y: scroll;
}

.group {
  padding: 15px;
  margin-bottom: 15px;
  background: rgba(0, 0, 0, 0.05);
}

.fuse {
  background: #fff;
  margin: 15px 0;
  padding: 8px;
  box-sizing: border-box;
  border: 2px dashed transparent;
}

.fuse.new {
  padding: 0;
  user-select: none;
  opacity: 0.5;
  font-size: 40px;
  text-align: center;
}

.fuse.drag-over {
  border-color: #888;
}
</style>
